import { Icon } from "../components/Icon.js";
import { AddUser, UserKpis, UserList, useUsers } from "../components/UserList.js";
import { useI18n } from "../i18n.js";
import { useSession } from "../session.js";

/**
 * La gestione utenti, portata da `Users.qml`.
 *
 * E' una schermata a se', non una scheda: nell'app desktop ci si arriva dalla
 * scheda AMMINISTRAZIONE delle impostazioni, e si torna indietro. Sopra le due
 * schede riassuntive, sotto l'elenco degli account — lo stesso pezzo che sta
 * dentro quella scheda, perche' e' la stessa cosa.
 *
 * **Serve il livello 5.** Chi non ce l'ha vede il motivo e la strada per
 * tornare, non una tabella vuota: una schermata vuota si legge come un
 * programma rotto, e manda a cercare un guasto che non c'e'.
 */
export function Users({ onBack }: { onBack?: (() => void) | undefined }) {
  const { t } = useI18n();
  const { phase } = useSession();
  const me = phase.kind === "authenticated" ? phase.user : undefined;
  const { users, denied, error, setError, reload } = useUsers();

  if (denied || (me !== undefined && me.level < 5)) {
    return (
      <div className="denied">
        <Icon name="shield" size={64} />
        <h2>{t("users.accessDenied")}</h2>
        <p className="muted">{t("users.superAdminRequired")}</p>
        {onBack && <button onClick={onBack}>{t("users.backToSettings")}</button>}
      </div>
    );
  }

  return (
    <div className="users">
      <header className="users__head">
        {onBack && (
          <button className="users__back" onClick={onBack}>
            <Icon name="arrow-left" size={20} />
          </button>
        )}
        <div>
          <h2>{t("users.userManagement")}</h2>
          <span className="users__sub">{t("users.accountAdmin").toUpperCase()}</span>
        </div>
        <span className="emissions__spacer" />
        <span className="brand">
          LMS<span>mini</span>
        </span>
      </header>

      {/* Il contenuto sta in 1200 px centrati, come il `ColumnLayout` del
          `.qml`. Senza, le schede degli account partivano dal bordo sinistro
          dello schermo e il marchio in intestazione finiva tagliato a
          destra. */}
      <div className="users__body">
      <UserKpis count={users.length} />

      <div className="admin__head">
        <h3 className="users__section">
          <Icon name="users" size={18} />
          {t("settings.userAccounts")}
        </h3>
        <span className="emissions__spacer" />
        <button className="iconbtn" title={t("settings.userAccounts")} onClick={() => void reload()}>
          <Icon name="refresh-cw" size={14} />
        </button>
      </div>

      {error && <p className="alert">{error}</p>}

      <UserList users={users} onChanged={() => void reload()} onError={setError} />
      <AddUser onCreated={() => void reload()} onError={setError} />
      </div>
    </div>
  );
}
